import { isPlatformBrowser, NgClass, NgIf } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { FuseCardComponent } from '@fuse/components/card';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AuthService } from 'app/core/auth/auth.service';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { StrapiService } from 'app/core/shared-services/strapi.service';
import { FooterComponent } from 'app/modules/landing/footer/footer.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { lastValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { sha256 } from 'js-sha256';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
@Component({
    selector: 'auth-sign-in',
    templateUrl: './sign-in.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [RouterLink, NgClass, FuseAlertComponent, FuseCardComponent, NgIf, FormsModule, ReactiveFormsModule,
        MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatProgressSpinnerModule,
        MatDialogModule, NgOtpInputModule, NgIf, FooterComponent],
})
export class AuthSignInComponent implements OnInit {
    @ViewChild('signInNgForm') signInNgForm: NgForm;

    public alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    public signInForm: UntypedFormGroup;
    public showAlert: boolean = false;
    public disableReSendOTP: boolean = true;
    public OTPcountDownActive: boolean = false;
    public showEmailInput: boolean = false;
    public showOTPInput: boolean = false;
    public otpTimer: number = 60;
    public timer: any;
    public accountAvailable: { IsAvailable: boolean, Message: string, Type: string };
    public image: string;
    public logo: string;
    public showSpinner: boolean;
    private emailAddress: string;
    private phoneNumber: any;
    private verificationId: number;
    private otp: number;
    private redirectURL: string;

    private referrer: string;

    public otpConfig : any = {
        length: 6,
        placeholder: '-',
        allowNumbersOnly: true,
        // Prevents internal errors if the library tries to access .button
        button: {
          show: false
        }
    }

    
    
    /**
     * Constructor
    */
   constructor(
       private _activatedRoute: ActivatedRoute,
       private _authService: AuthService,
       private _formBuilder: UntypedFormBuilder,
       private _router: Router,
       private dialog: MatDialog,
       private _strapiService: StrapiService,
       private router: Router,
       private _gtmService: GtmService,
       private _sharedMethods: SharedMethodsModule,
       
       @Inject(PLATFORM_ID) private platformId: any
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        if (isPlatformBrowser(this.platformId)) {

            if(localStorage.getItem('currentURL')) {
              if(localStorage.getItem('currentURL') == window.location.href) {
                //this.referrer = window.location.href
              } else {
                this.referrer = localStorage.getItem('currentURL')
                localStorage.setItem('currentURL', window.location.href);
                localStorage.setItem('previousURL', this.referrer);
              }
            } else {
              localStorage.setItem('currentURL', window.location.href);
            }
      
              const route = window.location.href;
              const path = this.router.url;
      
              this._gtmService.pushEvent({ 
                event: 'page_view',
                page_url: route,
                page_path: path,
                page_title: 'login_page',
                page_referrer: this.referrer ? this.referrer : route
              });
            }


        // get content from Strapi
        this._strapiService.getAuthScreenContent()
            .subscribe({
                next: (res: any) => {
                    this.image = res.data.image?.url;
                    this.logo = res.data.logo.url;
                }
            });

        // Create the form
        this.signInForm = this._formBuilder.group({
            Username: ['', [Validators.required, Validators.email]],
            Password: ['', Validators.required],
            rememberMe: [''],
        });

    }

    /**
     * On destroy
     */
    ngOnDestroy() {
        clearInterval(this.timer);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign in
     */
    signIn(): void {

        if (this.signInForm) {
            // Return if the form is invalid
            if (this.signInForm?.invalid) {
            return;
            }
    
            // Disable the form
            this.signInForm.disable();
    
            // Hide the alert
            this.showAlert = false;
    
            let route;
            let path;
            if (isPlatformBrowser(this.platformId)) {
                route = window.location.href;
                path = this.router.url;
            }
    
            // Sign in
            this._authService.signIn(this.signInForm.value)
                .subscribe(
                    async () => {
    
                        // console.log(this.signInForm.value);
                        // localStorage.setItem('emailHash', sha256(this.signInForm.value.Username));
                        this.getCustomerDetails();
    
    
                        // debugger
    
    
                        if(localStorage.getItem('currentURL')) {
                            if(localStorage.getItem('currentURL') == window.location.href) {
                              //this.referrer = window.location.href
                            } else {
                              this.referrer = localStorage.getItem('currentURL')
                              localStorage.setItem('currentURL', window.location.href);
                              localStorage.setItem('previousURL', this.referrer);
                            }
                          } else {
                            localStorage.setItem('currentURL', window.location.href);
                          }
    
                          let emailHash = '';
                        //   let phoneHash = '';
    
                          if (!this._gtmService.reg_emailHash) { emailHash = sha256(this.signInForm.value.Username)
                          } else {
                              emailHash = this._gtmService.reg_emailHash
                          }
      
                        //   if (!this._gtmService.reg_phoneHash) { phoneHash = sha256(this.signInForm.value.Password)
                        //   } else {
                        //       phoneHash = this._gtmService.reg_phoneHash
                        //   }
    
                            this._gtmService.pushEvent({
                                event: 'login',
                                page_url: route,
                                page_path: path,
                                page_title: 'login_page',
                                page_referrer: this.referrer ? this.referrer : route,
                                email: emailHash
                            });
    
                        // Set the redirect url.
                        // The '/signed-in-redirect' is a dummy url to catch the request and redirect the user
                        // to the correct page after a successful sign in. This way, that url can be set via
                        // routing file and we don't have to touch here.

                        if (localStorage.getItem('redirectUrl')) {
                            this.redirectURL = localStorage.getItem('redirectUrl');
                            localStorage.removeItem('redirectUrl');
                        }
                        else {
                            this.redirectURL = '/dashboard';
                        }
    
                        const res = await this._sharedMethods.getCustomerAccount();
    
                        this.hashUserDetails(res);
                        // localStorage.setItem('emailHash', sha256(res?.result.PrimaryContactEmail));
                        // localStorage.setItem('phoneHash', sha256(res?.result.MobileUsername));
    
                        // Navigate to the redirect url
                        this._router.navigateByUrl(this.redirectURL);
    
    
                    },
                    (response) => {
                        
                        // Re-enable the form
                        this.signInForm.enable();
    
                        // Reset the form
                        this.signInNgForm.resetForm();
    
                        // Set the alert
                        this.alert = {
                            type: 'error',
                            message: 'Wrong email or password',
                        };
    
                        // Show the alert
                        this.showAlert = true;
    
    
                    },
                );
        }

    }

    /**
     * OTP Dialog
     */
    openOTPDialog(templateRef: any) {
        this.dialog.open(templateRef, {
            width: '500px',
            backdropClass: 'blurModalBackground'
        });
    }


    /**
     * OTP Value Change
     */
    phoneNumberChange(val: any) {
        let input = val?.target.value;
    
        // If the number starts with '0' and is exactly 10 digits long
        if (input.startsWith('0') && input.length === 10) {
            // Remove the '0' and add '+27'
            this.phoneNumber = '+27' + input.slice(1);
            // Perform the check
            this.checkAccountAvailablilty(null, this.phoneNumber);
        }
        // If the number starts with '+27' and is exactly 12 characters long
        else if (input.startsWith('+27') && input.length === 12) {
            // Set the number as is
            this.phoneNumber = input;
            // Perform the check
            this.checkAccountAvailablilty(null, this.phoneNumber);
        }
        // Otherwise, clear the input to prevent invalid formats
        else {
            this.phoneNumber = ''; // or set to a default if needed
        }

    }
    

    /**
     * Email Input Value Change
     */
    emailChange(val: any) {

        // custom validation
        const emailValidation = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        // compaire against custom validation
        const isEmailValid = emailValidation.test(val?.target.value);
        // if valid email check availablity
        if (isEmailValid) {
            this.emailAddress = val?.target.value
            this.checkAccountAvailablilty(this.emailAddress, null);
        }
    }

    /**
     * Regsiter Mobile Username
     */
    registerMobileUsername() {

        //require email address so Agility finds the user via email and links them
        this.showEmailInput = true;

    }

    /**
     * OTP Value Change
     */
    getOTP() {
        this.showSpinner = true;
        this.otpCountdown();

        // if email input is show, it means we need to register username first
        if (this.showEmailInput) {
            this._authService.registerUsernameAndSendOTP(this.emailAddress)
                .subscribe({
                    next: (res: { VerificationID: number }) => {
                        this.showSpinner = false;
                        this.verificationId = res.VerificationID;
                        this.showOTPInput = true;
                    }
                })
        } else {
            this._authService.requestMobileOTP(this.phoneNumber)
                .subscribe({
                    next: () => {
                        this.showSpinner = false;
                        this.alert = {
                            type: 'success',
                            message: 'OTP was successfully sent!'
                        };
                        this.showAlert = true;
                        this.showOTPInput = true;
                    },
                    error: (err: any) => {
                        this.showSpinner = false;
                        Swal.fire({
                            title: 'Error!',
                            text: 'Error has occurred when requesting an OTP!',
                            icon: 'error',
                            showCancelButton: false,
                            confirmButtonText: 'OKAY',
                            showConfirmButton: true,
                            customClass: {
                                htmlContainer: 'text-lg',
                                confirmButton: 'custom-button text-md',
                            }
                        });

                    }
                })
        }
    }

    /**
     * Submit OTP
     */
    async submitOTP() {
        // ## fixes for non json response ##
        await lastValueFrom(this._authService.loginWithOTP(this.phoneNumber, this.otp)).then(async (res) => {
            this.showOTPInput = false;
            this.dialog.closeAll();
            const token = res.replace('Basic ', '');
            localStorage.setItem("accessToken", token);
            const user = await this._sharedMethods.getCustomerAccount();

            this.hashUserDetails(user)
            // localStorage.setItem('emailHash', sha256(user?.result.PrimaryContactEmail));
            // localStorage.setItem('phoneHash', sha256(user?.result.MobileUsername));

            this._authService._authenticated = true;
            this._router.navigateByUrl('/dashboard');
        }).catch(() => {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to verify otp.',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'OKAY',
                showConfirmButton: true,
                customClass: {
                    htmlContainer: 'text-lg',
                    confirmButton: 'custom-button text-md',
                }
            });
        });
    }




    /**
     * OTP Value Change
     */
    onOtpChange(val: any) {
        // only if the 6'th value is inserted, save the otp
        if (val.length == 6) {
            this.otp = val
        }
    }

    goToSignUp() {
        this.closeDialog();
        this._router.navigateByUrl('/sign-up');
    }

    public closeDialog() {
        this.dialog.closeAll();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------


    /**
     * OTP countdown timer
     */
    private otpCountdown() {
        this.timer = setInterval(() => {
            if (this.otpTimer > 0) {
                this.OTPcountDownActive = true;
                this.otpTimer--;
            } else {
                clearInterval(this.timer);
                this.OTPcountDownActive = false
                this.disableReSendOTP = false;
                // Timer has finished, you can handle what happens next here
            }
        }, 1000);
    }

    /**
     * Account availablity
     */
    private checkAccountAvailablilty(email: string, phoneNumber: number) {
        this._authService.accountAvailability(email, null, phoneNumber)
            .subscribe({
                next: (res: any) => {

                    this.accountAvailable = { IsAvailable: res.IsAvailable, Message: 'none', Type: email !== null ? 'email' : 'phoneNumber' };
                },
                error: (err: any) => {

                    this.accountAvailable = { IsAvailable: false, Message: err.error.Message, Type: email !== null ? 'email' : 'phoneNumber' };
                }
            })
    }


    public async getCustomerDetails() {
        await this._sharedMethods.getCustomerAccount().then(async (res) =>{ 
        });
    }

    public hashUserDetails(user: any) {
        if (!localStorage.getItem('emailHash')) {
            localStorage.setItem('emailHash', sha256(user?.result?.PrimaryContactEmail));
        }
        if (!localStorage.getItem('phoneHash')) {
            localStorage.setItem('phoneHash', sha256(user?.result?.PrimaryContactMobile));
        }
    }
}
